import React, { useEffect } from 'react';
import {
  Wrap,
  Header,
  List,
  ListItem,
  Summary,
  Thumb,
  NoneContent
} from './styled';
import useTypeStore from '../../../../hooks/useTypeStore';
import { observer } from 'mobx-react';
import { Link, useHistory } from 'react-router-dom';
import { timeUtils } from '../../../../common/utils/timeUtil';
import { StringUtil } from '../../../../common/utils/stringUtil';
import useModalStore from '../../../../hooks/useModalStore';
import useCheckLogin from '../../../../hooks/useCheckLogin';
import Seo from '../../../../components/seo';
import { ScoreUtil } from '../../../../common/utils/scoreUtil';

const Analysis = observer(({ gameId, sportsType, sportsId }) => {
  const { isCheckLogin } = useCheckLogin();
  const history = useHistory();
  const type = 'sports_analysis';
  const modal = useModalStore();
  const communityStore = useTypeStore('communityStore');
  const { items, loading } = communityStore;

  useEffect(() => {
    communityStore.actionList({ gameId, type, page: 1 });
  }, []);

  const onClickCommunityWrite = () => {
    if (!isCheckLogin) {
      modal.openConfirmModal({
        message: '로그인 후 사용이 가능 합니다. 로그인 하시겠습니까?',
        okCallback: () => history.push('/auth/login')
      });
    } else {
      history.push(
        `/community/write?type=${type}&gameId=${gameId}&sportsType=${sportsType}&sportsId=${sportsId}`
      );
    }
  };

  return (
    <Wrap>
      <Seo title={`스포츠 ${ScoreUtil.getSportName(sportsType)} 상세 분석글`} />
      <Header>
        <h3>경기 분석글을 공유해주세요.</h3>
        <button onClick={onClickCommunityWrite} />
      </Header>
      {items.length === 0 && !loading && (
        <NoneContent>
          <p>작성된 분석글이 없습니다.</p>
        </NoneContent>
      )}
      <List>
        {items.map((item, key) => {
          const {
            wr_id,
            wr_subject,
            wr_name,
            time,
            wr_datetime,
            wr_good,
            wr_hit,
            isThumb,
            thumbnail
          } = item;
          return (
            <ListItem key={key}>
              <Link
                to={`/community/sports_analysis?id=${wr_id}&type=${type}&gameId=${gameId}&sportsType=${sportsType}&sportsId=${sportsId}`}
              >
                <Summary isThumb={isThumb}>
                  <p className={'subject'}>{wr_subject}</p>
                  <span>{wr_name}</span>
                  <div>
                    <span>
                      {timeUtils.getDifferenceDay(wr_datetime.split(' ')[0]) ===
                      0
                        ? time
                        : StringUtil.replace(
                            '-',
                            '.',
                            wr_datetime.split(' ')[0]
                          )}
                    </span>
                    <span className={'like'}>{wr_good}</span>
                    <span className={'hit'}>{wr_hit}</span>
                  </div>
                </Summary>
                {isThumb && (
                  <Thumb className="Thumb">
                    <img
                      src={thumbnail}
                      alt="thumbnail"
                      onError={(event) => {
                        event.currentTarget.parentElement.style.display =
                          'none';
                      }}
                    />
                  </Thumb>
                )}
              </Link>
            </ListItem>
          );
        })}
      </List>
    </Wrap>
  );
});

export default Analysis;
